
/**
*   工具函数集中管理
**/
var __Xtool_Utils = (function () {
    /**
     * @param { String } msg 
     * @param { Number } duration 
     */
    var Toast = function (msg, duration) {
        duration = isNaN(duration) ? 1000 : duration;
        const m = document.createElement('div');
        m.innerHTML = msg;
        m.style.cssText = "font-family:siyuan;max-width:60%;min-width: 150px;padding:0 14px;height: 40px;color: rgb(255, 255, 255);line-height: 40px;text-align: center;border-radius: 4px;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 999999;background: rgba(0, 0, 0,.7);font-size: 16px;";
        document.body.appendChild(m);
        setTimeout(function () {
            let d = 0.5;
            m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
            m.style.opacity = '0';
            setTimeout(function () {
                document.body.removeChild(m)
            }, d * 1000);
        }, duration);
    }

    /**
     * @param { String } url 
     */
    var includeLinkStyle = function (url) {
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = url;
        document.getElementsByTagName("head")[0].appendChild(link);
    }

    /**
     * 
     * @param { String } value 
     * @returns Boolean
     */
    var isMobileNumber = function (value) {
        value = value.replace(/[^-|\d]/g, '');
        return (
            /^((\+86)|(86))?(1)\d{10}$/.test(value) || /^0[0-9-]{10,13}$/.test(value)
        );
    }

    /**
     * @returns Boolean
     */
    var isMobile = function () {
        return window.innerWidth <= 1024;
    }

    /**
     * 
     * @param { String } str 
     * @returns void
     */
    var copyToClipboard = function (str, successText = 'Copy successfully!', failText = 'Copy failure!',needToast = true) {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);

        const selection = document.getSelection();

        if (!selection) {
            return;
        }

        const selected = selection.rangeCount > 0 ? selection.getRangeAt(0) : false;

        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        if (selected) {
            selection.removeAllRanges();
            selection.addRange(selected);
            needToast && Toast(successText);
        } else {
            needToast && Toast(failText);
        }
    }

    /**
     * @param { Number } timestamp 
     * @returns  String
     */
    var getDateStr = function (timestamp) {
        var date = new Date(timestamp * 1000);
        var Y = date.getFullYear();
        var M = (date.getMonth() + 1).toString().padStart(2, '0');
        var D = date.getDate().toString().padStart(2, '0');
        return [Y, M, D].join('-');
    }

    var dateFormat = function (timestamp, format) {
        if (!timestamp) {
            return ''
        }
        let date = new Date(timestamp)
        const fullYear = date.getFullYear();
        const result = format.replace('YYYY', fullYear)
            .replace('YY', fullYear.toString().slice(-2))
            .replace('MM', (date.getMonth() + 1).toString().padStart(2, '0'))
            .replace('DD', date.getDate().toString().padStart(2, '0'))
            .replace('HH', date.getHours().toString().padStart(2, '0'))
            .replace('mm', date.getMinutes().toString().padStart(2, '0'))
            .replace('ss', date.getSeconds().toString().padStart(2, '0'))

        return result
    }

    function getCustomerId() {
        return getCookie('customer_id') || window.theme?.customer_id || '';
    };

    function getAccessToken() {
        const PROXY_TOKEN_STORAGE_KEY = 'mkProxyToken'
        return window.localStorage.getItem(PROXY_TOKEN_STORAGE_KEY) || '';
    }

    function isB2bCustomer() {
        if (window.makeblock && window.makeblock.customer && window.makeblock.customer.b2b) {
            return true;
        }
        return false;
    }

    /**
     * @returns  Object
     */
    var getSignatureHeader = function () {
        try {
            var timeStamp = Math.floor(Date.now().toString() / 1000);
            let secretKey = "7b141a46c423977f9d2dae3a0777cfa2";
            let sign_str = CryptoJS.MD5(timeStamp + ":" + secretKey).toString();
            let obj = {
                'Content-Type': 'application/json',
                'sign_str': sign_str,
                'time_stamp': timeStamp,
                'X-Mk-Shopify-Store': getStore(),
            };
            const customerId = getCustomerId();
            if (customerId) {
                obj['X-Mk-Shopify-Customer-ID'] = customerId
            }
            if (isB2bCustomer()) {
                const access_token =  getAccessToken()
                if(access_token) {
                    obj['X-Mk-Shopify-Session-Token'] = access_token
                }
            } else {
                const utoken = getCookie('utoken');
                if (utoken) {
                    obj['utoken']= utoken
                }
            }
            // if(customerId) {
            //     obj = {
            //         'sign_str': sign_str,
            //         'time_stamp': timeStamp,
            //         'X-Mk-Shopify-Store': getStore(),
            //         'X-Mk-Shopify-Customer-ID': getCustomerId(),
            //         'utoken': getCookie('utoken')
            //     }
            // }
            return obj
        } catch (error) {
            console.error('获取签名失败', error);
        }
    }

    /**
     * @returns xcc生产地址
     */
    var getXccApiDomain = function () {
        const shopName = getStore();
        if (['testxtool', 'wholesale-xtool-test'].includes(shopName)) {
            return '//dtc-api-test.xtool.com'
        }
        return '//dtc.mblock.cc'
    }

    var getStore = function () {
        return Shopify.shop.split('.')[0]
    }

    /**
     * 
     * @param { Number } endTimeTimestamp 
     * @param { Number } startTimeTimestamp 
     * @returns 
     */

    const countDown = function (params) {

        const {
            startTimeTimestamp,
            endTimeTimestamp,
            index
        } = params || {};

        if (params) {
            window.sessionStorage.setItem('startTimeTimestamp', startTimeTimestamp)
            window.sessionStorage.setItem('endTimeTimestamp', endTimeTimestamp)
            window.sessionStorage.setItem('countdownIndex', index)
        }

        let timer = null;
        let isExpired = false;
        const nowTime = new Date();
        const beginDiff = parseInt((!startTimeTimestamp ? window.sessionStorage.getItem('startTimeTimestamp') : startTimeTimestamp) * 1000 - nowTime.getTime());
        const endDiff = parseInt((!endTimeTimestamp ? window.sessionStorage.getItem('endTimeTimestamp') : endTimeTimestamp) * 1000 - nowTime.getTime());
        const leftTime = beginDiff > 0 ? beginDiff : endDiff;

        const day = parseInt(leftTime / (24 * 60 * 60 * 1000));
        const hour = parseInt(leftTime / (60 * 60 * 1000) % 24);
        const minute = parseInt(leftTime / (60 * 1000) % 60);
        const second = parseInt(leftTime / 1000 % 60);

        if (beginDiff > 0) {
            timer = setTimeout(countDown, 1000);
            isExpired = false;
        } else if (leftTime <= 0) {
            clearTimeout(timer);
            window.sessionStorage.removeItem('startTimeTimestamp');
            window.sessionStorage.removeItem('endTimeTimestamp');
            window.sessionStorage.removeItem('countdownIndex');
            isExpired = true;
        } else {
            $(`.count-down__wrapper-${!index ? window.sessionStorage.getItem('countdownIndex') : index} .hour-msg`).text(hour);
            $(`.count-down__wrapper-${!index ? window.sessionStorage.getItem('countdownIndex') : index} .mins-msg`).text(minute);
            $(`.count-down__wrapper-${!index ? window.sessionStorage.getItem('countdownIndex') : index} .secs-msg`).text(second);
            timer = setTimeout(countDown, 1000);
            isExpired = false;
        }

        return isExpired;
    }

    /**
     * 辅助函数，返回访问页面的设备类型（PC、Mobile、Pad）
     * @returns 'Pad' | 'Mobile' | 'PC'
     */
    const platform = function () {
        let ua = navigator.userAgent,
            isWindowsPhone = /(?:Windows Phone)/.test(ua),
            isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
            isAndroid = /(?:Android)/.test(ua),
            isFireFox = /(?:Firefox)/.test(ua),
            isChrome = /(?:Chrome|CriOS)/.test(ua),
            isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
            isPhone = /(?:iPhone)/.test(ua) && !isTablet,
            isPc = !isPhone && !isAndroid && !isSymbian;

        return isTablet ? 'Pad' : (isPhone || isAndroid) ? 'Mobile' : isPc ? 'PC' : 'PC';
    }

    /**
     * 解析地址栏参数，保存在params对象中
     * @returns url参数对象
     */
    const getQueryParams = function () {
        var query = location.search.substring(1)
        var arr = query.split('&')
        var params = {}
        for (var i = 0; i < arr.length; i++) {
            var pair = arr[i].split('=')
            params[pair[0]] = pair[1]
        }
        return params
    }

    /**
     * 兼容PC、移动端的点击事件
     */
    const tap = function (ele, callback) {
        if (this.platform() !== 'PC') {
            $(ele).on('touchstart', function (event) {
                callback(event);
            })
        } else {
            $(ele).on('click', function (event) {
                callback(event)
            })
        }
    }

    /** 动态创建script标签 */
    const loadScript = function (url, attr = {}, cb) {
        let script = document.createElement('script');
        script.src = url;
        Object.keys(attr).forEach(key => {
            script[key] = attr[key]
        })
        let firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.append(script, firstScript);

        // script 加载完毕后调用方法
        script.onload = script.onreadystatechange = function () {
            if (!this.readyState     //这是FF的判断语句，因为ff下没有readyState这个值，IE的readyState肯定有值
                || this.readyState == 'loaded' || this.readyState == 'complete'   // 这是IE的判断语句
            ) {
                cb && cb()
            }
        };
    }


    var listeners = [];
    var doc = document;
    var observer;
    function observerEleReady(selector, fn) {
        // 储存选择器和回调函数
        listeners.push({
            selector: selector,
            fn: fn
        });
        if (!observer) {
            // 监听document变化
            observer = new MutationObserver(check);
            observer.observe(doc.documentElement, {
                childList: true,
                subtree: true
            });
        }
        // 检查该节点是否已经在DOM中
        check();
    }

    function check() {
        // 检查是否匹配已储存的节点
        for (var i = 0; i < listeners.length; i++) {
            var listener = listeners[i];
            // 检查指定节点是否有匹配
            var elements = document.querySelectorAll(listener.selector);
            for (var j = 0; j < elements.length; j++) {
                var element = elements[j];
                // 确保回调函数只会对该元素调用一次
                if (!element.ready) {
                    element.ready = true;
                    // 对该节点调用回调函数
                    listener.fn.call(element, element);
                }
            }
        }
    }

    function firstWordToUpperCase(word) {
        return word.slice(0, 1).toLocaleUpperCase() + word.slice(1)
    }

    function exceptionNotification(errTitle = '异常提示"', errorMsg = '') {
        getIpLocation().then((countryName) => {
            const message = createFeishuMessage(errTitle, countryName, errorMsg);
            sendFeishuMessage(message);
        });

        function getHeaders() {
            var headers = {};
            for (var key in navigator) {
                if (
                    key.indexOf("appVersion") !== -1 ||
                    key.indexOf("userAgent") !== -1 ||
                    key.indexOf("platform") !== -1
                ) {
                    headers[key] = navigator[key];
                }
            }
            return headers;
        }

        function getIpLocation() {
            return fetch("https://dtc.mblock.cc/shopify/ip", { method: "GET" })
                .then((response) => response.json())
                .then((res) => {
                    return res.data.country_name;
                });
        }

        function createFeishuMessage(title, countryName, error = '') {
            return JSON.stringify({
                msg_type: "post",
                content: {
                    post: {
                        zh_cn: {
                            title: title,
                            content: [
                                [
                                    {
                                        tag: "text",
                                        text: `ip: - ${countryName}\n`,
                                    },
                                    {
                                        tag: "text",
                                        text: `请求头: ${JSON.stringify(
                                            getHeaders()
                                        )}\n`,
                                    },
                                    {
                                        tag: "text",
                                        text: `用户id: ${window.theme.customer_id}\n`,
                                    },
                                    {
                                        tag: "text",
                                        text: `${error}\n`,
                                    },
                                    {
                                        tag: "text",
                                        text: `href: ${window.location.href}\n`,
                                    },

                                ],
                            ],
                        },
                    },
                },
            });
        }

        function sendFeishuMessage(message) {
            const feishuBot = `https://open.feishu.cn/open-apis/bot/v2/hook/4ef03b5d-6743-4a0f-a4c0-eaa5ae322600`;
            fetch(feishuBot, {
                method: "POST",
                body: `${message}`,
            });
        }
    }


    function fetchFeishuMessage(feishuBot, message) {
        fetch(feishuBot, {
            method: 'POST',
            mode: 'no-cors', //加这个字段才可以在浏览器里面直接发起ajax请求
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify(message),
        });
    }

    // 飞书通知优化版本
    function feishuNotification(config) {
        // 配置
        var baseConfig = {
          errorTitle: '异常提示', //错误title，便于区分错误类别
          isTest: false, //是否是测试，测试的话，不会执行飞书通知
          errorMsg: '', //错误详细信息
          errorLevel: 1, //报警级别，默认1级
          responsiblePerson: '', //错误负责人
          feishuBot:
            'https://open.feishu.cn/open-apis/bot/v2/hook/4ef03b5d-6743-4a0f-a4c0-eaa5ae322600', //上报的飞书群webhook
          errorResolvePage:
            'https://makeblock.feishu.cn/wiki/AwRwwlgVLig9WAktt3Pcq9Wlnod?table=tblCsC7OcLAAsJSJ&view=vew2op0261', //上报的飞书群错误处理文档
          feishutTemplateId: 'ctp_AA1WWaWGD6hU', //上报的飞书群消息卡片,可在搭建工具中通过"复制卡片ID"获取
        };
        var finalConfig = {};
        function mergeConfig(baseConfig, config) {
          if (!config || !config.errorMsg) {
            return;
          }
          for (var key in config) {
            if (Object.prototype.hasOwnProperty.call(config, key)) {
              if (key === 'isTest') {
                baseConfig[key] =
                  config[key] === undefined ? baseConfig[key] : config[key];
              } else {
                baseConfig[key] = config[key] || baseConfig[key];
              }
            }
          }
          return baseConfig;
        }
        try {
          finalConfig = mergeConfig(baseConfig, config) || {};
          if (
            finalConfig === null || finalConfig === void 0
              ? void 0
              : finalConfig.isTest
          ) {
            return;
          }
        } catch (e) {
          console.info('mergeConfig报错', e);
          return;
        }
        var submitErrorUids = []; //错误去重过滤
        Promise.resolve(getIpLocation()).then(function (countryName) {
          var message = createFeishuMessage(finalConfig, countryName);
          sendFeishuMessage(message);
        });
        function getHeaders() {
          var headers = {};
          for (var key in navigator) {
            if (
              key.indexOf('appVersion') !== -1 ||
              key.indexOf('userAgent') !== -1 ||
              key.indexOf('platform') !== -1
            ) {
              headers[key] = navigator[key];
            }
          }
          return headers;
        }
        function getIpLocation() {
          try {
            // 读取数据时检查过期时间
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var storedData = JSON.parse(localStorage.getItem('feishuPostIps'));
            if (storedData && storedData.expiration > new Date().getTime()) {
              return storedData.data.dtcStationCountryName;
            } else {
              return fetch('https://dtc.mblock.cc/shopify/ip', { method: 'GET' })
                .then(function (response) {
                  return response.json();
                })
                .then(function (res) {
                  // 存储数据和过期时间
                  var data = { dtcStationCountryName: res.data.country_name };
                  var expiration = new Date().getTime() + 3600000 * 24; // 设置过期时间为1天（以毫秒为单位）
                  localStorage.setItem(
                    'feishuPostIps',
                    JSON.stringify({ data: data, expiration: expiration }),
                  );
                  return res.data.country_name;
                });
            }
          } catch (error) {
            console.info('getIpLocation报错', e);
            return '';
          }
        }
        function createFeishuMessage(finalConfig, countryName) {
          var _a, _b, _c, _d, _e, _f, _g, _h;
          return {
            msg_type: 'interactive',
            card: {
              type: 'template',
              data: {
                template_id: finalConfig.feishutTemplateId,
                template_variable: {
                  errorMsg: finalConfig.errorMsg,
                  responsiblePerson: finalConfig.responsiblePerson,
                  station: window.location.hostname,
                  pageUrl: window.location.href,
                  ip: countryName,
                  requestHeader: ''.concat(JSON.stringify(getHeaders())),
                  userId:
                    (_b =
                      (_a =
                        window === null || window === void 0
                          ? void 0
                          : window.makeblock) === null || _a === void 0
                        ? void 0
                        : _a.customer) === null || _b === void 0
                      ? void 0
                      : _b.id,
                  userEmail:
                    (_d =
                      (_c =
                        window === null || window === void 0
                          ? void 0
                          : window.makeblock) === null || _c === void 0
                        ? void 0
                        : _c.customer) === null || _d === void 0
                      ? void 0
                      : _d.email,
                  errorLevel: finalConfig.errorLevel,
                  errorTitle: finalConfig.errorTitle,
                  errorResolvePage: finalConfig.errorResolvePage,
                  errorEnv: ''
                    .concat(
                      (_f =
                        (_e =
                          window === null || window === void 0
                            ? void 0
                            : window.Shopify) === null || _e === void 0
                          ? void 0
                          : _e.theme) === null || _f === void 0
                        ? void 0
                        : _f.name,
                      ',role:',
                    )
                    .concat(
                      (_h =
                        (_g =
                          window === null || window === void 0
                            ? void 0
                            : window.Shopify) === null || _g === void 0
                          ? void 0
                          : _g.theme) === null || _h === void 0
                        ? void 0
                        : _h.role,
                    ),
                },
              },
            },
          };
        }
        // 初始化上报方法
        function sendFeishuMessage(message) {
          try {
            // const hasSubmitErrorStatus = hasSubmitError(message);
            // if (hasSubmitErrorStatus) return;
            return typeof navigator.sendBeacon === 'function'
              ? beaconTransport(message)
              : fetchSendMessage(message);
          } catch (e) {
            console.info('sendFeishuMessage报错', e);
          }
        }
        // beacon 形式上报
        function beaconTransport(message) {
          var status = window.navigator.sendBeacon(
            finalConfig.feishuBot,
            JSON.stringify(message),
          );
          // 如果数据量过大，则本次大数据量用 fetchSendFeishuMessage 上报
          if (!status) fetchSendMessage(message);
        }
        function fetchSendMessage(message) {
            fetchFeishuMessage(finalConfig.feishuBot, message);
        }
    }

    function feishuSendInteractiveMessage(config) {
        const { body, header, feishuBot } = config;
        const message = {
            msg_type: "interactive",
            card: {
                schema: "2.0",
                config: {
                    update_multi: true,
                    style: {
                        text_size: {
                            normal_v2: {
                                default: "normal",
                                pc: "normal",
                                mobile: "heading",
                            },
                        },
                    },
                },
                body,
                header,
            },
        };
        fetchFeishuMessage(feishuBot, message);
    }
    // 设置cookie，seconds以秒为单位
    function setCookie(name, value, seconds) {
        var expires = "";
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    // 获取cookie
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // 移除cookie
    function deleteCookie(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
    }

    function checkEmail(value) {
        var pattern = /^([A-Za-z0-9_\-\.\+])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/;
        return pattern.test(value);
    };


    // 获取顶部的高度(header+topbar)
    function getHeaderFixedHeight() {
        const topbar = $('#topbar');
        const header = $('.header-nav');
        // const topbarHeight = topbar.height() || 0;
        const topbarHeight = 0;
        const headerHeight = header.height() || 0;

        const productPage = isProductPage();
        if (window.innerWidth > 1024 || window.scrollY === 0) {
            return productPage ? topbarHeight : topbarHeight + headerHeight;
        } else {
            return productPage ? 0 : headerHeight;
        }
    }


    // 判断是否在可视区域
    function isElementInViewport(el) {
        if (!el) {
            return false;
        }
        // 获取元素是否在可视区域
        var rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <=
            (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    /*
    ** header导航栏阴影更新逻辑
    ** @params: otherFixedNode: 依赖页面其他固定节点，如果页面滚动中有其他节点需要固定，阴影需要隐藏
    */

    function updateHeaderShadow(otherFixedNode) {
        if ($('body').hasClass('position-fixed')) return;
        let top = 0;
        const headerHeight = getHeaderFixedHeight();
        if (otherFixedNode) {
            top = otherFixedNode.getBoundingClientRect().top;
        }
        if (window.scrollY > 20 && (!top || top > headerHeight)) {
            $('.header-nav').addClass('shadow');
        } else {
            $('.header-nav').removeClass('shadow');
        }
    }

    function updateHeaderFixedState() {
        const navContent = $('#main-menu-mobile-v2');
        // 手机端导航展开时，不执行该逻辑
        if (isProductPage() || navContent?.hasClass('isOpen')) return;
        if ($('body').hasClass('position-fixed')) return;
        if (window.innerWidth <= 1024) {
            if (window.scrollY > 0) {
                $('.header-nav').addClass('header-section--fold-topbar');
                $('.topbar').addClass('topbar--fold-topbar');
                $('#MainContent').addClass('main-content--fold-topbar')
                // $('.topbar-container').addClass('topbar--hide');
            } else {
                $('.header-nav').removeClass('header-section--fold-topbar');
                $('.topbar').removeClass('topbar--fold-topbar');
                $('#MainContent').removeClass('main-content--fold-topbar')
                // $('.topbar-container').removeClass('topbar--hide');
            }
        }
    }

    function isProductPage() {
        return window.location.pathname.indexOf('/products/') === 0
    }

    function getSectionByName(sectionName) {
        if (!sectionName || typeof sectionName != 'string') {
            return '';
        }
        sectionName = sectionName.split(',').filter(t => t != '').join(',');  // 过滤 ssss,  这样的格式
        const len = sectionName.split(',').length;
        return fetch(window.Shopify.routes.root + `?sections=${sectionName}`)
            .then(res => res.json())
            .then(res => {
                return len > 1 ? res : res[sectionName];
            }).catch(() => {
                throw new Error();
            })
    }
    function scrollIntoView(ele) {
        if (!ele) {
            return;
        }
        const elePosTop = ele.getBoundingClientRect().top;
        const headerHeight = __Xtool_Utils.getHeaderFixedHeight();  // 顶部的高度(header+topbar)
        const eleTarPosTop = elePosTop + window.pageYOffset - headerHeight; // 目标top
        window.scrollTo({ top: eleTarPosTop, behavior: "smooth" });
    }
    function getEmarsysCustomerId(email, store) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: "https://dtc.mblock.cc/xtool-creators-club/v1/customers/id",
                type: "GET",
                headers: getSignatureHeader(),
                data: {
                    store,
                    email
                }
            }).done(function (response) {
                if (response.code === 0 && response.data && response.data.id) {
                    resolve(response.data.id);
                }
            })
        })
    }

    function t(path) {
        const keys = path.split('.');
        let value = window.global_locales;
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (value && typeof value === 'object' && key in value) {
                value = value[key];
            } else {
                return undefined;
            }
        }
        return value;
    }

    /**
     * 懒加载 图片、视频
     * @param {Object} options
     * @param {Element | Element[]} options.target - 目标元素
     * @param {IntersectionObserverInit=} options.observerOptions - IntersectionObserver的参数
     * @param {string=} options.sourceAttr - 源属性，默认为src
     * @param {string | string[] | undefined} options.replaceAttr - 替换属性，默认为data-src,如果是数组，则会找到第一个有值的属性替换
     * @param {{sourceAttr:string,replaceAttr:string | string[]}[]=} options.batchAttrOptions - 批量替换属性 该属性存在时，会忽略上面的sourceAttr、replaceAttr
     */
    const lazyLoad = (options) => {
        let { target, observerOptions, sourceAttr = 'src', replaceAttr = 'data-src', batchAttrOptions } = options;
        let finalAttrOptions = batchAttrOptions || [{ sourceAttr, replaceAttr: replaceAttr }];
        if (!target) return;
        if (!target.forEach) {
            target = [target]
        }
        if (!target.length) return;
        // 加载资源
        const loadResource = (element) => {
            // 判断是否为picture标签、video标签、audio标签,如果是的话，需要连带替换source的属性
            const tagName = element.tagName.toLowerCase();
            let targetEle = [element];
            if (['video', 'audio', 'picture'].includes(tagName)) {
                const sourceEle = element.querySelectorAll('source') || [];
                const imgEle = element.querySelectorAll('img') || [];

                targetEle = targetEle.concat([...sourceEle, ...imgEle]);
            }
            targetEle.forEach(function (ele) {
                // 替换属性
                finalAttrOptions.forEach(function (item) {
                    const { sourceAttr, replaceAttr } = item;
                    let replaceAttrVal = '', replaceAttrArr = replaceAttr;
                    if (!Array.isArray(replaceAttr)) {
                        replaceAttrArr = [replaceAttr];
                    }
                    // 找到第一个有值的属性替换
                    replaceAttrArr.some(function (attr) {
                        replaceAttrVal = ele.getAttribute(attr);
                        return replaceAttrVal;
                    })
                    // 都没有值则return
                    if (!replaceAttrVal) return;
                    ele[sourceAttr] = replaceAttrVal;
                })
            })
        }
        const observerCallback = (entries, observer) => {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    // 进入可视区域，加载图片资源
                    const ele = entry.target;
                    loadResource(ele);
                    // 停止监听
                    observer.unobserve(ele);
                }
            });
        }
        const observer = new IntersectionObserver(observerCallback, observerOptions || { rootMargin: '0px', threshold: 0 });
        target.forEach(function (item) {
            observer.observe(item);
        })

        return observer;
    }
  
    function getCurrentVariant(params) {
        const queryParams = getQueryParams();
        const variantId = queryParams.variant;
        const variantList = window?.makeblock?.product?.variants;
        const result = variantList.find((item) => String(item.id) === variantId) || window?.makeblock?.product?.selected_or_first_available_variant;
        return result;
    }

    function throttle(func, delay) {
        let lastCall = 0;
        return function(...args) {
            const now = (new Date).getTime();
            if (now - lastCall >= delay) {
                lastCall = now;
                return func.apply(this, args);
            }
        };
    }


    /**
     * 
     * @param {object} params 
     * @param {string} params.name - abtest名称
     * @param {string|boolean|number} params.defaultValue - 默认值
     * @param {function} params.callback - 回调函数
     * @returns 
     */
    const fetchPtABTest = (params)=>{
        const {defaultValue,name,callback} = params;
        // 如果已经有值，直接返回
        if(window.ptABTest && window.ptABTest[name]!== undefined){
            callback(window.ptABTest[name] && window.ptABTest[name].value);
            return;
        }
        // 监听事件
        document.addEventListener(name, function (e) {
            const value = e.detail && e.detail.value;
            callback(value);
        });
    }

    // 编码
    function encode (str) {
        if (!str) return '';
        const encoder = new TextEncoder();
        const bytes = encoder.encode(str);
        return btoa(String.fromCharCode(...bytes));
    }

    // 封装fetch请求
    function fetchJSON(url, options = {}) {
        var headers = getSignatureHeader();
        options.headers = headers;
        return new Promise((resolve, reject) => {
            window.fetch(url, options)
                .then(res => {
                    if (!res.ok) {
                        throw new Error(`请求失败: ${res.status} ${res.statusText}`);
                    }
                    return res.json();
                })
                .then(resolve)
                .catch(reject);
        });
    }

    const DATE_FORMAT = {
        testxtool: {
          DATE: 'MM/DD/YYYY',
          DATE_TIME: 'MM/DD/YYYY HH:mm:ss',
        },
        'makeblock-xtool': {
          DATE: 'MM/DD/YYYY',
          DATE_TIME: 'MM/DD/YYYY HH:mm:ss',
        },
        'xtool-australia-store': {
          DATE: 'DD/MM/YYYY',
          DATE_TIME: 'DD/MM/YYYY HH:mm:ss',
        },
        'wholesale-xtool-test': {
          DATE: 'MM/DD/YYYY',
          DATE_TIME: 'MM/DD/YYYY HH:mm:ss',
        },
        'ca-xtool': {
          DATE: 'YYYY-MM-DD',
          DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
        },
        'eu-xtool': {
          DATE: 'DD/MM/YYYY',
          DATE_TIME: 'DD/MM/YYYY HH:mm:ss',
        },
        // todo 未处理完
        'uk-xtool': {
          DATE: 'DD/MM/YYYY',
          DATE_TIME: 'DD/MM/YYYY hh:mm:ss a',
        },
        'de-xtool': {
          DATE: 'DD/MM/YYYY',
          DATE_TIME: 'DD/MM/YYYY HH:mm:ss',
        },
        'fr-xtool': {
          DATE: 'DD/MM/YYYY',
          DATE_TIME: 'DD/MM/YYYY HH:mm:ss',
        },
        'jp-xtool': {
          DATE: 'YYYY-MM-DD',
          DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
        },
        'cool-gadget-4015': {
          DATE: 'MM/DD/YYYY',
          DATE_TIME: 'MM/DD/YYYY HH:mm:ss',
        },
        makeblock: {
          DATE: 'MM/DD/YYYY',
          DATE_TIME: 'MM/DD/YYYY HH:mm:ss',
        },
        default: {
          DATE: 'MM/DD/YYYY',
          DATE_TIME: 'MM/DD/YYYY HH:mm:ss',
        },
      };
      

    // 根据时间戳、时区返回时间，时间格式为：YYYY-MM-DD HH:mm:ss
    const getDateTimeStr = (timestamp, shopTimeZone) => {
        const shop = window.Shopify.shop.split('.')[0];
        // 默认当前系统时间戳
        let shopTimestamp = dayjs().valueOf();
        if (timestamp) {
            shopTimestamp = timestamp;
        }
        let dateFormat = DATE_FORMAT[shop];
        if (!dateFormat) {
            dateFormat = DATE_FORMAT.default;
        }
        // 转换为店铺时区的时间字符串，时间格式化
        const time = dayjs(shopTimestamp).tz(shopTimeZone).format(dateFormat.DATE_TIME);
        // 获取时区偏移量
        const offset = dayjs().tz(shopTimeZone).utcOffset();
        // 获取时区偏移量对应的GTM偏移
        const offsetGTM = offset / 60;
        return `${time} (GMT${offset > 0 ? '+' : ''}${offsetGTM})`;
  };

    /**
     * 计算商品阶梯折扣
     * @param {number} price - 商品价格（单位：元）
     * @param {Array} ladderDiscountRules - 阶梯折扣规则数组
     * @returns {number} 折扣金额（单位：元）
     */
    var calculateLadderDiscount = function(price, ladderDiscountRules) {
        if (!Array.isArray(ladderDiscountRules) || ladderDiscountRules.length === 0) {
            return 0;
        }

        // 按价格从小到大排序
        var sortedRules = ladderDiscountRules.slice().sort(function(a, b) {
            return a.price - b.price;
        });
        
        var discount = 0;
        for (var i = 0; i < sortedRules.length; i++) {
            if (price >= sortedRules[i].price) {
                discount = sortedRules[i].discount;
            }
        }

        return discount;
    };

    /**
     * 检查变体ID是否符合配置规则
     * @param {string|number} variantId - 变体ID
     * @param {Array} includeList - 包含列表
     * @param {Array} excludeList - 排除列表
     * @returns {boolean} 是否符合规则
     */
    var isVariantAllowed = function(variantId, includeList, excludeList) {
        if (!variantId) return true;
        
        var variantIdStr = String(variantId);
        
        // 检查排除列表
        if (Array.isArray(excludeList) && excludeList.length > 0) {
            for (var i = 0; i < excludeList.length; i++) {
                if (String(excludeList[i]) === variantIdStr) {
                    return false; // 在排除列表中，不允许
                }
            }
        }
        
        // 检查包含列表
        if (Array.isArray(includeList) && includeList.length > 0) {
            // 如果包含列表第一个元素为空字符串，表示包含所有
            if (includeList[0] === "" || includeList[0] === null) {
                return true;
            }
            // 否则检查是否在包含列表中
            for (var j = 0; j < includeList.length; j++) {
                if (String(includeList[j]) === variantIdStr) {
                    return true;
                }
            }
            return false; // 不在包含列表中，不允许
        }
        
        return true; // 没有限制，允许
    };

    /**
     * 获取商品类型对应的阶梯折扣配置
     * @param {string} productType - 商品类型
     * @param {string|number} [variantId] - 变体ID
     * @returns {Object|null} 阶梯折扣配置对象
     */
    var getLadderDiscountConfig = function(productType, variantId) {
        var productLadderDiscount = window.makeblock && window.makeblock.final_price_product_ladder_discount || [];
        
        // 优先检查全局配置（没有type的配置）
        if (variantId) {
            for (var i = 0; i < productLadderDiscount.length; i++) {
                var config = productLadderDiscount[i];
                // 全局配置：没有type字段，通过include_variant_id匹配
                if (!config.type && config.include_variant_id) {
                    if (config.include_variant_id.includes(String(variantId))) {
                        return config;
                    }
                }
            }
        }
        
        // 检查产品类型配置（有type的配置）
        for (var i = 0; i < productLadderDiscount.length; i++) {
            var config = productLadderDiscount[i];
            if (config.type === productType) {
                // 检查变体ID是否被排除
                if (variantId && config.exclude_variant_id && config.exclude_variant_id.includes(String(variantId))) {
                    continue; // 变体ID被排除，跳过
                }
                return config;
            }
        }
        
        return null;
    };

    /**
     * 检查是否为特殊商品（不参与到手价计算）
     * @param {Array} productTags - 商品标签数组
     * @returns {boolean}
     */
    var isSpecialProduct = function(productTags) {
        return productTags.includes('SMB Special');
    };

    /**
     * 检查是否为耗材商品
     * @param {string} productType - 商品类型
     * @returns {boolean}
     */
    var isMaterialProduct = function(productType) {
        return productType === (window._shopifyProductPageSetting && window._shopifyProductPageSetting.productType && window._shopifyProductPageSetting.productType.material);
    };

    /**
     * 计算耗材特殊价格（8折）
     * @param {number} price - 原价格（单位：元）
     * @param {number} carePrice - Care价格（单位：元，默认为0）
     * @returns {number} 计算后的价格（单位：元）
     */
    var calculateMaterialPrice = function(price, carePrice) {
        carePrice = carePrice || 0;
        return (price - carePrice) * 0.8 + carePrice;
    };

    /**
     * 价格单位转换：分转元
     * @param {number} priceInCents - 价格（单位：分）
     * @returns {number} 价格（单位：元）
     */
    var centsToYuan = function(priceInCents) {
        return priceInCents / 100;
    };

    /**
     * 价格单位转换：元转分
     * @param {number} priceInYuan - 价格（单位：元）
     * @returns {number} 价格（单位：分）
     */
    var yuanToCents = function(priceInYuan) {
        return priceInYuan * 100;
    };

    /**
     * 计算百分比折扣后的价格
     * @param {number} price - 原价格（单位：元）
     * @param {number} percentage - 折扣百分比（0.1表示9折）
     * @returns {number} 折扣后价格（单位：元）
     */
    var calculatePercentageDiscount = function(price, percentage) {
        if (!percentage || percentage <= 0) {
            return price;
        }
        
        // 预估到手价 = 售价 * (1 - 折扣百分比)
        var discountedPrice = price * (1 - percentage);
        
        // 保留两位小数，第二位小数进1
        return roundUpToTwoDecimals(discountedPrice);
    };

    /**
     * 价格进位到两位小数，第二位小数进1
     * @param {number} price - 原价格
     * @returns {number} 进位后的价格
     */
    var roundUpToTwoDecimals = function(price) {
        // 第二位小数向上进位
        // 例如：1000.123 → 1000.13
        // 先放大100倍，向上取整，再除以100
        return Math.ceil(price * 100) / 100;
    };

    /**
     * 核心价格和折扣计算函数
     * @param {Object} params - 计算参数
     * @param {string} params.productType - 商品类型
     * @param {Array} params.productTags - 商品标签数组
     * @param {number} params.price - 商品价格（单位：分）
     * @param {number} [params.carePrice=0] - Care价格（单位：元）
     * @param {number} [params.compareAtPrice] - 划线价（单位：分），用于计算总折扣
     * @param {string|number} [params.variantId] - 变体ID，用于精确匹配配置
     * @returns {Object} 计算结果
     */
    var calculatePriceAndDiscount = function(params) {
        var productType = params.productType;
        var productTags = params.productTags;
        var priceInCents = params.price;
        var carePrice = params.carePrice || 0;
        var compareAtPrice = params.compareAtPrice || 0;
        var variantId = params.variantId;

        // 初始化返回值（只返回核心计算结果）
        var result = {
            originalPrice: priceInCents,           // 原价格（分）
            finalPrice: priceInCents,              // 最终到手价（分）
            ladderDiscount: 0,                     // 阶梯折扣金额（分）
            percentageDiscount: 0,                 // 百分比折扣金额（分）
            totalDiscount: 0,                      // 总折扣金额（分，相对于划线价或原价）
            isSpecialProduct: false,               // 是否特殊商品
            isMaterialProduct: false,              // 是否耗材
            ladderDiscountConfig: null             // 阶梯折扣配置
        };

        try {
            // 检查是否为特殊商品
            if (productTags && productTags.length > 0) {
                result.isSpecialProduct = isSpecialProduct(productTags);
            }
            // 获取阶梯折扣配置（支持变体ID匹配）
            var ladderDiscountConfig = getLadderDiscountConfig(productType, variantId);
            result.ladderDiscountConfig = ladderDiscountConfig;
            if (result.isSpecialProduct || !ladderDiscountConfig || !ladderDiscountConfig.enable) {
                if (compareAtPrice > 0) {
                    result.totalDiscount = compareAtPrice - result.originalPrice;
                }
                return result;
            }

            // 转换价格单位：分转元
            var price = centsToYuan(priceInCents);

            // 检查是否为耗材
            result.isMaterialProduct = isMaterialProduct(productType);
            
            var finalPriceInYuan = price;
            var percentageDiscountAmount = 0;
            
            if (result.isMaterialProduct) {
                // 耗材特殊处理：8折，不再走其他折扣逻辑
                finalPriceInYuan = calculateMaterialPrice(price, carePrice);
                result.finalPrice = yuanToCents(finalPriceInYuan);
            } else {
                // 非耗材：处理百分比折扣或阶梯折扣
                if (ladderDiscountConfig.percentage && ladderDiscountConfig.percentage > 0) {
                    // 使用百分比折扣：预估到手价 = 售价 * (1 - 折扣百分比)
                    finalPriceInYuan = calculatePercentageDiscount(price, ladderDiscountConfig.percentage);
                    percentageDiscountAmount = price - finalPriceInYuan;
                    
                    // 转换回分单位
                    result.finalPrice = yuanToCents(finalPriceInYuan);
                    result.percentageDiscount = yuanToCents(percentageDiscountAmount);
                    
                } else {
                    // 使用阶梯折扣
                    var ladderDiscountInYuan = calculateLadderDiscount(price, ladderDiscountConfig.discount);
                    
                    // 计算最终价格
                    finalPriceInYuan = price - ladderDiscountInYuan;
                    
                    // 转换回分单位
                    result.finalPrice = yuanToCents(finalPriceInYuan);
                    result.ladderDiscount = yuanToCents(ladderDiscountInYuan);
                }
            }

            // 计算总折扣（节省金额）
            if (compareAtPrice > 0) {
                if (result.finalPrice < result.originalPrice) {
                    // 情况1：有原价且有预估到手价优惠
                    // 节省金额 = 原价 - 预估到手价
                    result.totalDiscount = compareAtPrice - result.finalPrice;
                } else {
                    // 情况3：有原价但没有预估到手价优惠
                    // 节省金额 = 原价 - 售价
                    result.totalDiscount = compareAtPrice - result.originalPrice;
                }
            } else {
                if (result.finalPrice < result.originalPrice) {
                    // 情况2：没有原价但有预估到手价优惠
                    // 节省金额 = 售价 - 预估到手价
                    result.totalDiscount = result.originalPrice - result.finalPrice;
                } else {
                    // 没有任何优惠
                    result.totalDiscount = 0;
                }
            }

            return result;

        } catch (error) {
            console.error('价格计算出错:', error);
            return result;
        }
    };


    function openBotModal() {
        const botIcon = document.querySelector('#mk-bot-icon')
        if (botIcon) {
            botIcon.click()
        }
    }

    //监听 Alpine 初始化完成后，执行回调方法
    const awaitAlpineInitialized = (fn) => {
        if (window.Alpine && window.Alpine.mk_initialized) {
            fn(); // Alpine 已经初始化完成，直接执行回调
        } else {
            document.addEventListener('alpine:initialized', () => {
                fn(); // Alpine 未初始化，监听初始化事件
            });
        }
    }  
    
    
        var getDateStrByIanaTimezone = function (timestamp, shopTimeZone, store = 'makeblock-xtool') {
        // 默认当前系统时间戳
        let shopTimestamp = dayjs().valueOf();
        if (timestamp) {
            shopTimestamp = timestamp;
        }
        if (store === 'uk-xtool' || store === 'wholesale-xtool-test') {
          return dayjs(shopTimestamp).tz(shopTimeZone).format('MM/DD/YYYY');
        }else{
          // 转换为店铺时区的时间字符串，时间格式化
        const time = dayjs(shopTimestamp).tz(shopTimeZone).format('MM/DD/YYYY');
        // 获取时区偏移量
        const offset = dayjs().tz(shopTimeZone).utcOffset();
        // 获取时区偏移量对应的GTM偏移
        const offsetGTM = offset / 60;
        return `${time} (GMT${offset > 0 ? '+' : ''}${offsetGTM})`;
        }
        
    };

    return {
        Toast,
        includeLinkStyle,
        isMobileNumber,
        isMobile,
        copyToClipboard,
        getDateStr,
        dateFormat,
        getSignatureHeader,
        getCustomerId,
        getStore,
        getXccApiDomain,
        countDown,
        platform,
        getQueryParams,
        tap,
        loadScript,
        observerEleReady,
        firstWordToUpperCase,
        exceptionNotification,
        feishuNotification,
        feishuSendInteractiveMessage,
        setCookie,
        getCookie,
        deleteCookie,
        checkEmail,
        isElementInViewport,
        getHeaderFixedHeight,
        updateHeaderShadow,
        updateHeaderFixedState,
        isProductPage,
        getSectionByName,
        scrollIntoView,
        getEmarsysCustomerId,
        t,
        lazyLoad,
        getCurrentVariant,
        throttle,
        fetchPtABTest,
        encode,
        fetchJSON,
        getDateTimeStr,
        calculatePriceAndDiscount,
        openBotModal,
        awaitAlpineInitialized,
        getDateStrByIanaTimezone
    }
})();

/**
*   在init的同时传入相关参数
**/
; (function (win) {
    if (!win.jQuery) {
        $ = {};
        $.fn = {};
    } else if (!win.$) {
        win.$ = jQuery;
    }

    /**
     * 工具集
     * */
    $.tools = {
        format: function (str, data) {
            var matchs = str.match(/{[^}]+?}/g);

            if (matchs === null) {
                return '';
            }

            var maLen = matchs.length;
            data = data instanceof Array ? data : [data];

            var html = '';
            for (var n = 0, len = data.length; n < len; n++) {
                var obj = data[n];

                var temp = str;
                for (var i = 0; i < maLen; i++) {
                    var match = matchs[i];
                    var name = match.replace(/{|}/g, "");
                    temp = temp.replace(match, obj[name] || '');
                }

                html += temp;
            }

            return html;
        }
    }

    /*
    * 分页相关
    */
    $.Pager = function () {
        this.el = null

        this.inited = 0  //是否已经初始化过

        this.curPage = 1
        this.totalPage = 0

        this.total = 0
        this.pageSize = 10

        this.showJump = false;

        this.splitStr = '<li class="disabled"><span class="splitStr"></span></li>'

        this.template =
            '<div class="pager-list">' +
            '    <div class="pager-prev{prevAble}"><</div>' +
            '    <ul>{pageList}</ul>' +
            '    <div class="pager-next{nextAble}">></div>' +
            '</div>'
    }

    ///初始化
    $.Pager.init = function (opt) {
        var page = new $.Pager();

        for (var name in opt) {
            if (opt.hasOwnProperty(name)) {
                page[name] = opt[name];
            }
        }

        var el = opt && opt.el || '[pager]';
        el = typeof el === 'string' ? document.querySelector(el) : el;

        if (el.size && el.size() > 0) {
            el = el[0];
        }

        //元素是否存在
        if (!el) {
            console.error('请指定页码元素, 然后再刷新');
            return;
        }

        //是否显示jump
        page.showJump = page.showJump ? 'inline-block' : 'none';
        page.el = el;
        page.totalPage = Math.ceil(page.total / page.pageSize);
        page.updatePage();

        if (!page.inited) {
            page.inited = 1;
            page.event();
        }
    }

    ///更新页码
    $.Pager.prototype.updatePage = function () {
        var pageList = '';
        var start = this.curPage - 2 > 1 ? this.curPage - 2 : 2;
        var end = this.curPage + 2 < this.totalPage ? this.curPage + 2 : this.totalPage - 1;

        if (this.totalPage > 0) {
            //第一部分
            pageList += '<li';
            pageList += this.curPage === 1 ? ' class="cur"' : '';
            pageList += '>1</li>{splitBefore}';

            //中间页码
            for (var i = start; i <= end; i++) {
                pageList += '<li';
                pageList += i === this.curPage ? ' class="cur"' : '';
                pageList += '>' + i + '</li>';
            }
            // console.log(end, "endend")
            //最后部分
            if (this.totalPage != 1) {
                pageList += '{splitAfter}<li';
                pageList += this.curPage === this.totalPage ? ' class="cur"' : '';
                pageList += '>' + this.totalPage + '</li>';
            }
        }

        var splitData = {
            splitBefore: this.curPage > 2 ? this.splitStr : '',
            splitAfter: this.curPage < this.totalPage - 3 ? this.splitStr : ''
        };

        pageList = $.tools.format(pageList, splitData);


        //页码信息
        var pageData = {
            showJump: this.showJump,

            //上一页与下一页按钮控制
            prevAble: this.curPage === 1 ? ' disabled' : '',
            nextAble: this.curPage === this.totalPage || this.totalPage == 0 ? ' disabled' : '',

            curPage: this.curPage,
            totalPage: this.totalPage,
            pageSize: this.pageSize,
            total: this.total,

            pageList: pageList
        };

        var pageHtml = $.tools.format(this.template, pageData);

        if (!this.totalPage) {
            pageHtml = '';
        }

        this.el.innerHTML = pageHtml;
    }


    ///事件处理
    $.Pager.prototype.event = function () {
        var _this = this;

        _this.el.addEventListener("selectstart", function (e) { e.preventDefault(); });
        // if (__Xtool_Utils.isMobile()) {
        //     _this.el.addEventListener("touchstart", onClickLi, false);
        // } else {
        //     _this.el.addEventListener("click", onClickLi, false);
        // }

        _this.el.addEventListener("click", onClickLi, false);

        function onClickLi(e) {
            var target = e.target;
            var tagName = target.tagName;
            var page = target.textContent - 0;
            var className = target.className;

            if (target.classList.contains("disabled") || target.classList.contains("cur")) {
                return false;
            }

            switch (className) {
                case '': tagName === "LI" && _this.goPage(page); break;
                case 'pager-prev': _this.prev(); break;
                case 'pager-next': _this.next(); break;
                case 'jump-btn': _this.jump(); break;
            }
        }
    }

    $.Pager.prototype.prev = function () {
        if (this.curPage > 1) {
            this.curPage--
        } else {
            return;
        }
        this.goPage();
    }

    $.Pager.prototype.next = function () {
        if (this.curPage < this.totalPage) {
            this.curPage++
        } else {
            return;
        }
        this.goPage();
    }

    $.Pager.prototype.jump = function () {
        var inputEl = this.el.getElementsByTagName('input')[0];
        var pageIndex = inputEl.value.trim() - 0;
        if (isNaN(pageIndex)) {
            console.error('请输入数字');
            pageIndex = this.curPage;
        }
        this.goPage(pageIndex);
    }

    $.Pager.prototype.goPage = function (pageIndex) {
        this.curPage = pageIndex || this.curPage;

        this.curPage = this.curPage < 1 ? 1 : this.curPage;
        this.curPage = this.curPage > this.totalPage ? this.totalPage : this.curPage;

        this.updatePage();
        this.onJump && this.onJump(this.curPage);
    }

    return $.Pager;
})(window);


; (function () {
    if (!String.prototype.replaceAll) {
        String.prototype.replaceAll = function (search, replacement) {
            // 将搜索字符串中的特殊字符进行转义
            var searchRegex = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            // 创建正则表达式，并使用全局匹配模式
            var regex = new RegExp(searchRegex, 'g');
            // 使用替换字符串替换所有匹配项
            return this.replace(regex, replacement);
        };
    }
})(window)

// '<div class="pager-info">'+
//     '<span class="pager-index-tip">共{total}条,每页{pageSize}</span>'+
//     '<span class="pager-index-tip">{curPage}/{totalPage}</span>'+
//     '<div class="pager-jump" style="display:{showJump}">' +
//         '跳转到 <input value="{curPage}" maxlength="6" />' +
//         '<button class="jump-btn">确定</button>'+
//     '</div>' + 
// '</div>'+
